import script from "./PersonalizedEmailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalizedEmailsView.vue?vue&type=script&setup=true&lang=js"

import "./PersonalizedEmailsView.vue?vue&type=style&index=0&id=38fc125a&lang=scss"

const __exports__ = script;

export default __exports__